import React, { useRef, useEffect } from 'react';
import './TestimonialSection.css';

function TestimonialSection() {
    // Create an array of refs for each video
    const videoRefs = useRef([]);
    videoRefs.current = [useRef(), useRef(), useRef(), useRef()];

    useEffect(() => {
        const handlePlay = (currentIdx) => {
            videoRefs.current.forEach((ref, idx) => {
                if (idx !== currentIdx && ref.current && !ref.current.paused) {
                    ref.current.pause();
                }
            });
        };

        const playEventListeners = videoRefs.current.map((ref, index) => {
            const onPlay = () => handlePlay(index);
            return { ref, onPlay };
        });

        // Add event listeners to each video
        playEventListeners.forEach(({ ref, onPlay }) => {
            if (ref.current) {
                ref.current.addEventListener('play', onPlay);
            }
        });

        // Clean up event listeners
        return () => {
            playEventListeners.forEach(({ ref, onPlay }) => {
                if (ref.current) {
                    ref.current.removeEventListener('play', onPlay);
                }
            });
        };
    }, []);

    // Quotes for each testimonial
    const quotes = [
        "The time that I spend in the gym has much more purpose nowadays, given the plans he has given me.",
        "Working with Terry really showed me how to not only be patient, but also be dilligent in terms of PT, strength, recovery, mobility, all the things that only a trainer knows how to implement.",
        "I lost 2 inches of belly fat during the challenge which is remarkable - I feel more confident - overall I would say that Terry's workout plan and coaching have shifted my belief system on fitness, physical wellness, definitely pushed me out of my comfort zone, and helped me get out of a rut.",
        "What I really loved is that Terry really listened when I shared my specific fitness goals - he catered our workouts and made sure that I was getting absolutely everything and more out of every single session."
    ];


    const emailTestimonials = [
        {
            content: "After working out on my own for about 9 months I realized I wasn’t maximizing my time at the gym or seeing significant change. Although I had an idea of what I wanted to achieve I didn’t know how to get there. Terry listened to my goals and immediately started building a plan for me. He was quick to get me into a routine that focuses on full body strength, not just lifting. With Terry being an athletic coach and head of the NYU track program outside of personal training, I was confident in his ability to personalize a plan for me and my goals. We focus on a lot of compound movements and full body exercises that build muscle and burn calories, while also making time for more specific muscle strength training. He keeps our sessions fresh by constantly bringing in new movements that I wouldn’t know about otherwise. After working with Terry for about 10 months I feel more confident in my training and more comfortable going to the gym on my own to supplement my sessions. Terry is also very knowledgeable with nutrition and diet. One of my main goals when starting with Terry was to develop a diet that supported the training for maximum results. Terry has helped me develop better eating habits without proposing any restrictive or overly calorie conscious methods. Terry has taught me the importance of macro nutrients and encouraged me to reach certain intake levels without being too structured or telling me exactly what to eat. Terry is willing to go as deep into the process as you want but is always responsible with his advice. In just 10 months there is a noticeable difference in how my clothes fit but more importantly a difference in how I feel. I am lifting heavier than I ever would’ve thought I could after only 10 months of work. I feel stronger and am seeing the results in everyday life. As I’ve reached certain goals, new ones arise and Terry will seamlessly adjust our program to continue growing. Overall I’m extremely happy with the results and enjoy each session with Terry. I’m also grateful to Terry for making the gym a comfortable place for me, which it hasn’t always been.",
            author: "Sam Kopit"
        },
        {
            content: "I have been training with Terry consistently for over 5 years and I recommend engaging him with your training routine. Terry’s focus on functional training, agility, weights, and boxing has increased and maintained my strength and endurance.  Working with Terry has caused my training to be consistent over a long period, including during the virus.  I would have regressed during the lockdowns if it were not for Terry keeping me motivated and encouraging me to keep up my strength training. Terry is fanatical about form, and as a result I have never been injured from his workouts.  Unlike other trainers who are distracted by their phones while their clients exercise, during our sessions Terry is totally focused on me and my form and anticipating our next move, whether we are in the club or training virtually. I am a 42 year old female and at my age muscle loss is inevitable and rapid without dedicated strength training. At the same time, there is so much toxic diet culture, especially in New York City.  In the past, I had negative experiences with other trainers who were too focused on weight loss or unattainable outcomes like “bikini body” or “before and after” body.  Terry understands that being told “You lost weight” is not something that I seek, or even consider a compliment.  He is attuned to my goals and does not measure progress with the number on the scale or proliferate toxic diet culture. Follow his program and you will get stronger!!!",
            author: "Michelle Roberts"
        }
    ];

    return (
        <div id="testimonials" className="testimonial-section">
            <h2>Testimonials</h2>
            <div className="testimonials-container">
                {[1, 2, 3, 4].map((index) => (
                    <div key={index} className="testimonial">
                        <video controls className="testimonial-video" ref={videoRefs.current[index - 1]}>
                            <source src={`IMG_${index === 1 ? '0025' : index === 2 ? '8374' : index === 3 ? '1100' : '0570'}.mp4`} type="video/mp4" />
                            Your browser does not support the video tag.
                        </video>
                        <p className="testimonial-quote">
                            {quotes[index - 1]}
                        </p>
                    </div>
                ))}
            </div>
            {/* Email Testimonials Section */}
            <div className="email-testimonials-container">
                <h3>Written Testimonials</h3>
                {emailTestimonials.map((testimonial, index) => (
                    <div key={index} className="email-testimonial">
                        <p className="testimonial-content">{testimonial.content}</p>
                        <p className="testimonial-author">{testimonial.author}</p>
                    </div>
                ))}
            </div>
        </div>
    );
}

export default TestimonialSection;
